import { OperationType } from 'app/constants/operationType'

export const getOperationTypeName = (
  operationType: OperationType,
  translate: (string) => string,
): string => {
  const text: string = OperationType[operationType]
  return translate(`operationType.${text}`)
}
